import { useState } from "react";
import { useTranslation } from 'react-i18next';
import { TextField, Checkbox, FormControlLabel } from "@mui/material";
import styles from "../../pages/Company.module.css";

const CHECKBOX_SX = {
  color: "var(--primary-color)",
  "&.Mui-checked": { color: "var(--primary-color)" },
  "&:hover": { backgroundColor: "var(--transparent-hover-color)" },
  "& .MuiTouchRipple-root": { color: "var(--primary-color)" },
};

// mode: "invite" | "edit"
const MemberFormModal = ({ mode, member, onClose, onSubmit }) => {
  const { t } = useTranslation();
  const isEdit = mode === "edit";

  const [fullName, setFullName] = useState(member?.full_name || "");
  const [email, setEmail] = useState(member?.email || "");
  const [isAdmin, setIsAdmin] = useState(isEdit ? member?.role === "admin" : false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = isEdit
        ? { ...member, full_name: fullName, email, role: isAdmin ? "admin" : "member" }
        : { full_name: fullName, email, is_admin: isAdmin };
      await onSubmit(payload);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <h3>{isEdit ? t('members.modal_edit_title') : t('members.modal_invite_title')}</h3>
        <form onSubmit={handleSubmit}>
          <TextField
            label={t('common.name')}
            value={fullName}
            onChange={e => setFullName(e.target.value)}
            fullWidth
            margin="normal"
            required={!isEdit}
          />
          <TextField
            label={t('common.email')}
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            fullWidth
            margin="normal"
            required={!isEdit}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={isAdmin}
                onChange={e => setIsAdmin(e.target.checked)}
                sx={CHECKBOX_SX}
              />
            }
            label={t('members.is_admin')}
            sx={{ color: "var(--inverse-color)", mt: 1 }}
          />
          <div className={styles.buttonsContainer}>
            {isEdit && (
              <button type="button" className={`button thirdly-button ${styles.cancelButton}`} onClick={onClose}>
                {t('common.cancel')}
              </button>
            )}
            <button type="submit" className={`button ${styles.saveButton}`} disabled={loading}>
              {isEdit ? t('common.save') : (loading ? t('members.sending') : t('members.invite_btn'))}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MemberFormModal;
